
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.813.031l-28 5.313c-.473.09-.813.52-.813 1v37.312c0 .48.34.91.813 1l28 5.313c.062.011.125.031.187.031.23 0 .445-.07.625-.219.23-.191.375-.484.375-.781V1c0-.297-.145-.59-.375-.781-.23-.192-.52-.242-.813-.188zM36.656 7c-1.605 0-3.164.082-4.656.25v6.438a42.09 42.09 0 005.063.312C45.44 14 50 11.836 50 10.719v-.375C49.937 9.148 44.879 7 36.656 7zM50 13.5c-2.727 1.656-7.848 2.5-12.938 2.5-1.738 0-3.457-.094-5.062-.281V24c1.598.195 3.32.281 5.063.281C45.44 24.281 50 22.117 50 21zm-33.625 1.344c1.953 6.527 3.82 13.09 5.75 19.625-1.348-.09-2.695-.192-4.031-.313a211.18 211.18 0 00-1.125-4.375c-1.79-.008-3.594-.07-5.375-.156-.344 1.383-.676 2.75-1.031 4.125-1.141-.09-2.301-.145-3.438-.219 1.703-6.136 3.496-12.27 5.188-18.406 1.359-.098 2.699-.176 4.062-.281zm-2.188 3.469c-.39 2.769-1.253 5.43-1.843 8.156 1.281.011 2.554.023 3.844.031-.665-2.727-1.477-5.426-2-8.188zM50 23.78c-2.727 1.657-7.848 2.5-12.938 2.5-1.738 0-3.457-.093-5.062-.281v7.688a42.09 42.09 0 005.063.312C45.44 34 50 31.836 50 30.719zm0 9.719c-2.727 1.656-7.848 2.5-12.938 2.5-1.738 0-3.453-.094-5.062-.281v7.031c1.492.168 3.05.25 4.656.25C44.93 43 50 40.812 50 39.625z"}})])
          )
        }
      }
    